import React, { useEffect, useRef } from "react";
import { menu } from "../Navbar";

// components
import DropDownMenu from "./DropDownMenu";

// img
import logo from "../../../images/header-logo.png";
import { Link } from "react-router-dom";

const MobileSidebar = ({ open, setOpen }) => {
  // outside click handler
  const useOutsideClick = (callback) => {
    const profileMenu = useRef();

    useEffect(() => {
      const handleClick = (event) => {
        if (
          profileMenu.current &&
          !profileMenu.current.contains(event.target)
        ) {
          callback();
        }
      };

      document.addEventListener("click", handleClick, true);

      return () => {
        document.removeEventListener("click", handleClick, true);
      };
    }, [profileMenu]);

    return profileMenu;
  };

  const sidebar = useOutsideClick(() => setOpen(false));

  return (
    <div className="">
      <div
        className={`absolute ${
          open ? "visible opacity-100" : "invisible opacity-0"
        } w-full top-0 bottom-0 bg-black bg-opacity-30 transition-all duration-300 z-[1000]`}
      ></div>
      <div
        className={`mobile-sidebar w-72 absolute bg-[#222] top-0 bottom-0 ${
          open ? "right-0" : "-right-96"
        } transition-all flex flex-col gap-4 pt-4 duration-300 overflow-auto z-[1000]`}
        ref={sidebar}
      >
        {/* logo & clos button */}

        <Link to={"/"} className="w-full flex justify-center items-center">
          <img src={logo} className="w-24" alt="" />
        </Link>

        {/* drop down menu */}
        {/* <h2 className="mt-10 mb-1 px-5 font-semibold">دسته بندی ها</h2> */}
        <nav className="flex flex-col gap-2 px-3">
          {menu.map((m) => (
            <DropDownMenu data={m} />
          ))}
        </nav>
      </div>
    </div>
  );
};

export default MobileSidebar;
